import {Search} from 'lucide-react';
import {useMemo} from 'react';

import {SortDropdown} from '../SortDropdown';
import {LocationRow} from './LocationRow';

export const BaselineAdminView = ({
  data,
  searchTerm,
  setSearchTerm,
  sortBy,
  setSortBy,
  showSortDropdown,
  setShowSortDropdown,
  collapsedLocations,
  toggleLocationCollapse,
  getStatusLabel,
}) => {
  const filteredAndSortedData = useMemo(() => {
    let filtered = data;

    if (searchTerm) {
      filtered = data.filter((location) =>
        location.location_name.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    return filtered.sort((a, b) => {
      switch (sortBy) {
        case 'alphabetical':
          return a.location_name.localeCompare(b.location_name);
        case 'least_completed':
          if (a.completion_percentage !== b.completion_percentage) {
            return a.completion_percentage - b.completion_percentage;
          }
          return b.in_progress_percentage - a.in_progress_percentage;
        case 'most_completed':
          if (a.completion_percentage !== b.completion_percentage) {
            return b.completion_percentage - a.completion_percentage;
          }
          return b.in_progress_percentage - a.in_progress_percentage;
        default:
          return 0;
      }
    });
  }, [data, searchTerm, sortBy]);

  const handleSortDropdownToggle = () => {
    setShowSortDropdown(!showSortDropdown);
  };

  const handleSortChange = (value) => {
    setSortBy(value);
    setShowSortDropdown(false);
  };

  return (
    <div className='baseline-container'>
      <div className='baseline-wrapper'>
        <div className='baseline-card'>
          <div className='baseline-header'>
            <h1 className='baseline-title'>Location Baseline Compliance</h1>
            <div className='baseline-controls'>
              <div className='baseline-search-container'>
                <Search className='baseline-search-icon' />
                <input
                  type='text'
                  placeholder='Search location....'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className='baseline-search-input'
                />
              </div>
              <div className='baseline-button-group'>
                <SortDropdown
                  isAdmin={true}
                  showDropdown={showSortDropdown}
                  sortBy={sortBy}
                  onToggle={handleSortDropdownToggle}
                  onSortChange={handleSortChange}
                />
              </div>
            </div>
          </div>

          <div className='baseline-content'>
            {filteredAndSortedData.length === 0 ? (
              <div className='baseline-empty-state'>
                <div className='baseline-empty-text'>No locations found</div>
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm('')}
                    className='baseline-clear-filters'
                  >
                    Clear Filters
                  </button>
                )}
              </div>
            ) : (
              <div className='baseline-location-list'>
                {filteredAndSortedData.map((item) => (
                  <LocationRow
                    key={item.org_id}
                    org={item}
                    isCollapsed={collapsedLocations[item.location_name]}
                    onToggleCollapse={toggleLocationCollapse}
                    getStatusLabel={getStatusLabel}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
